/*  eslint-disable no-unused-vars, react/no-unescaped-entities */
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedin, faYoutube, faXTwitter } from '@fortawesome/free-brands-svg-icons';
import './SocialHandles.css';

const SocialHandles = () => (
  <div className="social-container">
    {/* eslint-disable jsx-a11y/control-has-associated-label */}
    <a target="_blank" rel="noreferrer" href="https://www.linkedin.com/in/rajeev-bakshi-10bb2a5/" className="linkedin social"> <FontAwesomeIcon icon={faLinkedin} size="2x" /> </a>
    {/* <a target="_blank" rel="noreferrer" href="https://www.youtube.com/@curvsort" className="youtube social"> <FontAwesomeIcon icon={faYoutube} size="2x" /> </a> */}
    <a target="_blank" rel="noreferrer" href="https://www.twitter.com/CurvSort" className="twitter social"> <FontAwesomeIcon icon={faXTwitter} size="2x" /> </a>
    {/* eslint-enable jsx-a11y/control-has-associated-label */}
  </div>
);

export default SocialHandles;
